import { useLayoutEffect, useState } from "react";
import { useMediaQuery } from "./media-query";

export { type ODSViewportSize, useViewportSize };

type ODSViewportSize = "small" | "medium" | "large" | "x-large" | "xx-large";

/**
 * Hook to determine the current viewport size.
 * Should only be used to determine logic, not styles.
 * For styles use css/customMedia.css
 */
const useViewportSize = () => {
  const [viewport, setViewport] = useState<ODSViewportSize>("large");
  const isMedium = useMediaQuery(`(min-width: 768px)`);
  const isLarge = useMediaQuery(`(min-width: 1040px)`);
  const isXLarge = useMediaQuery(`(min-width: 1440px)`);
  const isXXLarge = useMediaQuery(`(min-width: 1680px)`);

  useLayoutEffect(() => {
    if (isXXLarge) {
      setViewport("xx-large");
    } else if (isXLarge) {
      setViewport("x-large");
    } else if (isLarge) {
      setViewport("large");
    } else if (isMedium) {
      setViewport("medium");
    } else {
      setViewport("small");
    }
  }, [isXXLarge, isXLarge, isLarge, isMedium]);

  return viewport;
};
